// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2QUbK","title":"AfterFrontImage_title__1Z4bD"};